import { useCallback, useRef, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
export const useToggleFlag = (delay = 0) => {
  const timerId = useRef(null);
  const [flag, setFlag] = useState(false);
  const toggleFlag = useCallback(() => {
    setFlag(true);
  }, []);
  useDidUpdateEffect(() => {
    if (flag) {
      timerId.current = setTimeout(() => {
        setFlag(false);
      }, delay);
      return () => clearTimeout(timerId.current);
    }
  }, [flag]);
  return [flag, toggleFlag];
};